import { MeasurementSchedule, RoutineMeasurement, VideoCall } from "@/domain/entities/EntityFields";
import { Patient } from "@/domain/entities/Patient";
import { db, functions } from "@/infraestructure/datasource";
import { reactive, ref, Ref, toRefs } from "vue";
import useAuth from "./AuthState";
import { v4 as uuidv4 } from 'uuid';


interface DoctorState {
    patients: Patient[] | null,
    searchTerm: string,
    patientSelected: Patient | null,
}

const patientSelectedKey = 'doctor/patientSelected'
const writeToLocal = (key : string, value : any) => localStorage.setItem(key, JSON.stringify(value))
const readFromLocal = (key : string) => localStorage.getItem(key) === null ? null : JSON.parse(localStorage.getItem(key)!)
const state = reactive<DoctorState>({
    patients: null,
    searchTerm: '',
    patientSelected: readFromLocal(patientSelectedKey) as Patient | null,
})

const loadPatients = async () => {
    let patientDocs = await db.collection('patients').get()
    state.patients = patientDocs.docs.map((doc) => doc.data() as Patient)
}
const selectPatient = (patient : Patient) => {
    writeToLocal(patientSelectedKey, patient)
    state.patientSelected = patient;
}

let closeOnPatientDataChange : () => void | undefined;
const listenOnPatientDataChange = (patientId : string) => {
	closeOnPatientDataChange = db.collection('patients').doc(patientId).onSnapshot(
		(doc) => {
			let newStatePatient: Patient = doc.data() as Patient
			state.patientSelected = newStatePatient
		}
    )
    return closeOnPatientDataChange
}
const fetchSensorValuesFromPatient = async (patientId : string) : Promise<MeasurementRecord[]> => {
    let result = await db.collection(`patients/${patientId}/measurements`).get()
    return result.docs.map(d => d.data() as MeasurementRecord)
}

let closeSnapshot : any | undefined;
const watchSensorValuesFromPatient = (patientId : string) : Ref<MeasurementRecord[]> => {
    let records = ref<MeasurementRecord[]>([])
    if (closeSnapshot) {
        closeSnapshot()
    }
    closeSnapshot = db.collection(`patients/${patientId}/measurements`).orderBy('dateTime').onSnapshot((snapshot) => {
        records.value = snapshot.docs.map(d => d.data() as MeasurementRecord)
    })
    return records
}

// const insertDoctorNote = async (notes : DoctorNote[]) => {
//     await db.collection('patients').doc(state.patientSelected?.id).set({
//         doctorNotes: notes
//     }, {merge: true})
// }

const sendVideoCallRequest = async () : Promise<string> => {
    let user = useAuth().user.value!
    let doctorId = user.id
    let patientId = state.patientSelected?.id

    let newVideoCall = <VideoCall>{
        createdAt: new Date(),
        doctorId,
        id: uuidv4(),
    }

    await functions.httpsCallable('sendVideoCallRequest')({ patientId, body : newVideoCall})
    return newVideoCall.id
}

async function updateMeasurementSchedule(schedules: RoutineMeasurement[]) {
	let newSchedule = <MeasurementSchedule>{
		createdAt: new Date(),
		routine: schedules,
    };
    let patientId : string = (state.patientSelected as Patient).id
	// let scheduleList : MeasurementSchedule[] = (state.patientSelected as Patient).measurementSchedule || [];
	// scheduleList.push(newSchedule)

	await db.collection(`patients/${patientId}/measurement_schedules`).add(newSchedule)
	await db.collection('patients').doc(patientId).set(
		{
			lastMeasurementSchedule: newSchedule,
		},
		{ merge: true },
	)
}



export default function useDoctor() {
    return { ...toRefs(state), loadPatients, selectPatient, listenOnPatientDataChange, watchSensorValuesFromPatient,
        closeOnPatientDataChange, sendVideoCallRequest, updateMeasurementSchedule, fetchSensorValuesFromPatient  }
}